import {
  Activity,
  AlertTriangle,
  AppWindow,
  BadgeCheck,
  Banknote,
  BarChart3,
  Bell,
  Bot,
  Building2,
  CheckCircle2,
  Compass,
  Crosshair,
  Database,
  DollarSign,
  FileSignature,
  FileText,
  Gauge,
  Headphones,
  HelpCircle,
  Home,
  Inbox,
  LayoutDashboard,
  Lock,
  Map,
  MapPin,
  MapPinOff,
  Megaphone,
  MessageSquareText,
  Navigation,
  Package,
  Plug,
  Radar,
  Radio,
  Receipt,
  Rocket,
  RotateCcw,
  ScanLine,
  ScrollText,
  Settings,
  ShieldAlert,
  ShieldCheck,
  Sparkles,
  Store,
  Tag,
  Ticket,
  ToggleRight,
  TrendingUp,
  Truck,
  UserCheck,
  UserCog,
  UserPlus,
  Users,
  UsersRound,
  Wallet,
  Waypoints,
} from "lucide-react";

// ─────────────────────────────────────────────────────────────────────────────
// Mapa nombre Material Symbol (menuConfig) → ícono Lucide.
//
// El sidebar moderno usa lucide-react (el estándar GEN 2 del design system;
// material-symbols solo sobrevive en vistas híbridas viejas). menuConfig
// conserva los nombres material porque BottomNavigation todavía los renderiza
// como font; este mapa traduce solo para el sidebar. Un nombre sin entrada cae
// al <span> de material symbols, así un ítem nuevo nunca queda sin ícono.
// ─────────────────────────────────────────────────────────────────────────────
const MAPA = {
  // Operación
  space_dashboard: LayoutDashboard,
  list_alt: Package,
  dvr: Radio,
  event_repeat: ScanLine,
  wrong_location: MapPinOff,
  route: Waypoints,
  // Seguimiento
  sensors: Navigation,
  location_on: MapPin,
  explore: Compass,
  gps_fixed: Radar,
  my_location: Crosshair,
  // Análisis
  trending_up: TrendingUp,
  add_chart: FileText,
  verified: BadgeCheck,
  map: Map,
  check_circle: CheckCircle2,
  bar_chart: BarChart3,
  // Facturación
  request_quote: DollarSign,
  payments: Banknote,
  receipt: Receipt,
  wallet: Wallet,
  // Gestión
  manage_accounts: UserCog,
  // Conductores (choferes + equipo interno del operador)
  local_shipping: Truck,
  admin_panel_settings: ShieldCheck,
  // "domain" (más abajo, en Plataforma) sirve también al ítem Gestión →
  // Empresas (hub /admin/contracts, ex "Contratos"). handshake/how_to_reg
  // quedan mapeados por si algún menú legacy los sigue usando.
  handshake: FileSignature,
  how_to_reg: UserCheck,
  people: Users,
  group: UsersRound,
  groups: Users,
  // Soporte
  report: AlertTriangle,
  support_agent: Inbox,
  notifications_active: Bell,
  help: HelpCircle,
  // Plataforma (superadmin)
  smart_toy: Bot,
  database: Database,
  domain: Building2,
  person_add: UserPlus,
  sell: Tag,
  confirmation_number: Ticket,
  speed: Gauge,
  toggle_on: ToggleRight,
  rocket_launch: Rocket,
  campaign: Megaphone,
  chat: MessageSquareText,
  web_asset: AppWindow,
  auto_awesome: Sparkles,
  monitor_heart: Activity,
  warning: ShieldAlert,
  headset_mic: Headphones,
  fact_check: ScrollText,
  security: Lock,
  diversity_3: Users,
  settings: Settings,
  // Comercio / holding
  home: Home,
  integration_instructions: Plug,
  package_2: Package,
  sync_alt: RotateCcw,
  store: Store,
};

/**
 * Ícono de ítem del sidebar. Lucide 16px (w-4 h-4, como el resto del design
 * system GEN 2); si el nombre no está mapeado, degrada al glyph material.
 */
export function SidebarIcon({ name, className }) {
  const Lucide = MAPA[name];
  if (Lucide) {
    return <Lucide size={16} strokeWidth={2} className={className} aria-hidden="true" />;
  }
  return (
    <span className={`material-symbols-outlined ${className || ""}`} aria-hidden="true" data-icon={name}>
      {name}
    </span>
  );
}
